export default __webpack_public_path__ + "static/flower-e6f40dad5a53df91a4854b38ecc90da0.png";